import ProgressIndicator from 'components/ProgressIndicator/ProgressIndicator'
import HuskyCard from '../../../components/HuskyCard/HuskyCard'
import HuskyIvoBlock from '../../../components/HuskyIvoBlock/HuskyIvoBlock'
import { useProposalHuskyData } from './ProposalHuskyInitialization'
import { IProps } from '../../../lib/types'

const ProposalHusky = ({ proposals }: IProps) => {

    const {
        storageWithOverhead,
        storageWithOverheadRangeMax,
        storageWithOverheadUnitType,
        diskUtilization,
        diskUtilizationRangeMax,
        diskUtilizationUnitType,
        systemUtilization,
        systemUtilizationRangeMax,
        systemUtilizationUnitType,
        cameraStreams,
        cameraDataRate,
        clientDataRate,
        raidType
    } = useProposalHuskyData(proposals)    

   

    return (
        <>
            <div className="col-12 msds-text-header-2 msds-text-display-3 msds-text-dark-blue pb-5">Recommended solution</div>

            <div className="col-12 col-md-4 mb-4">
                <ProgressIndicator
                    headline="Total storage"
                    inputName="Required/Available"
                    initialValue={storageWithOverhead}
                    max={storageWithOverheadRangeMax}
                    unitType={storageWithOverheadUnitType}
                />
            </div>

            <div className="col-12 col-md-4 mb-4">
                <ProgressIndicator
                    headline={"Storage per server: " + raidType}
                    inputName="Required/Available"
                    initialValue={diskUtilization}
                    max={diskUtilizationRangeMax}
                    unitType={diskUtilizationUnitType}
                />
            </div>

            <div className="col-12 col-md-4 mb-4">
                <ProgressIndicator
                    headline="System utilization"
                    inputName="Load %"
                    initialValue={systemUtilization}
                    max={systemUtilizationRangeMax}
                    unitType={systemUtilizationUnitType}
                />
            </div>

            <div className="col-12 col-md-4 mb-4">
                <HuskyCard headline="Camera streams" label="Per server" value={cameraStreams} />
            </div>

            <div className="col-12 col-md-4 mb-4">
                <HuskyCard headline="Camera data rate" label="Per server" value={cameraDataRate} />
            </div>

            <div className="col-12 col-md-4 mb-4">
                <HuskyCard headline="Smart client data rate" label="Per server" value={clientDataRate} />
            </div>

            <div className="col-12 mb-4">
                <HuskyIvoBlock proposals={proposals} />
            </div>            
        </>
    )
}

export default ProposalHusky
